import type { ConceptDef } from '../types';

export const countObjects: ConceptDef = {
  kind: 'tileMatch',
  id: 'count-objects',
  label: 'Count Objects',
  category: 'Math',
  description: 'See a group; tap how many there are.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: '🍎🍎', answer: '2' },
      { say: '🍎🍎🍎', answer: '3' },
      { say: '🍎🍎🍎🍎', answer: '4' },
      { say: '🍎🍎🍎🍎🍎', answer: '5' },
      { say: '🍎🍎🍎🍎🍎🍎', answer: '6' },
    ],
  },
};
